import { all, takeEvery } from 'redux-saga/effects';
import { FETCH_FEATURED_HEAD_TO_HEAD } from '../actions';
import { fetchFeaturedHeadToHead } from './fetch-featured-head-to-head';

/**
 *
 */
export function* featuredHeadToHeadRootSaga() {
    yield all([
        takeEvery(FETCH_FEATURED_HEAD_TO_HEAD.REQUEST, fetchFeaturedHeadToHead)
    ]);
}
